import { getToken } from '../auth/tokenSource';

/**
 * Přílohy nejdou stáhnout obyčejným odkazem — API chce token v hlavičce a do URL ho
 * nedáváme. Stáhne se tedy přes fetch a uloží přes dočasnou blob URL.
 */
export async function downloadFile(url: string, fileName: string): Promise<void> {
  const token = await getToken();
  const response = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });

  if (!response.ok) {
    throw new Error('Soubor se nepodařilo stáhnout.');
  }

  const blobUrl = URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(blobUrl);
}

/** Nahrání souboru. Multipart, proto mimo typovaného klienta. */
export async function uploadFile(url: string, file: File, category: string): Promise<Response> {
  const token = await getToken();
  const form = new FormData();
  form.append('file', file);
  form.append('category', category);

  return fetch(url, {
    method: 'POST',
    body: form,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} kB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
